import groupBy from 'lodash/groupBy';

const getAssigneesWithStudents = (formData, allSections) => {
  const { students, assignees } = formData;
  const studentsBySection = groupBy(students, 'sectionId');
  const assigneeIdsByStudents = Object.keys(studentsBySection);

  const assigneesWithStudents = assigneeIdsByStudents.map((assigneeId) => {
    const assignee = allSections.find(({ id }) => id === assigneeId);
    const assigneeStudents = studentsBySection[assigneeId];
    return {
      id: assignee.id,
      studentIds:
        assigneeStudents.length === assignee.students.length
          ? []
          : assigneeStudents.map(({ studentId }) => studentId.toString()),
    };
  });

  const assigneesWithoutStudents = [];
  assignees.forEach(({ id, students }) => {
    if (!students.length) assigneesWithoutStudents.push({ id, studentIds: [] });
  });

  return assigneesWithStudents.concat(assigneesWithoutStudents);
};

export default getAssigneesWithStudents;
